import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';

@Component({
  selector: 'app-referal-details',
  templateUrl: './referal-details.component.html',
  styleUrls: ['./referal-details.component.css', '../shared/css/common.css']
})
export class ReferalDetailsComponent implements OnInit {
  isformloaded: boolean = false;
  instructionText!: string | null;
  isInstruction: boolean = false;
  isFormsValid: boolean = false;

  payorkey: number;
  isMember = false;
  profileMasterTypeKey: any;
  isExternalReferringParty: string = "No";
  primaryColor?: string = "";

  constructor(
    private referalFormBuilder: FormBuilder,
    private router: Router,
    private referalService: ReferalFormService,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal
  ) {
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata") ?? "");
    this.referalFormData = this.formdata.extenalReferall;
    this.referalFormDataPart1["subcontrols"] = this.formdata.extenalReferall.subcontrols.slice(0, 5);
    this.referalFormDataPart2["subcontrols"] = this.formdata.extenalReferall.subcontrols.slice(5, 9);
    this.referalFormDataPart3["subcontrols"] = this.formdata.extenalReferall.subcontrols.slice(9, 10);
    this.referalFormDataPart4["subcontrols"] = this.formdata.extenalReferall.subcontrols.slice(10, 11);
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
    this.isExternalReferringParty = this.formdata.extenalReferall.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value;
    this.formValidate();
  }

  formdata: any | null;
  referalForm = this.referalFormBuilder.group({});
  referalFormPart1 = this.referalFormBuilder.group({});
  referalFormPart2 = this.referalFormBuilder.group({});
  referalFormPart3 = this.referalFormBuilder.group({});
  referalFormPart4 = this.referalFormBuilder.group({});
  referalFormData: any = {};
  referalFormDataPart1: any = {};
  referalFormDataPart2: any = {};
  referalFormDataPart3: any = {};
  referalFormDataPart4: any = {};

  ngOnInit(): void {
    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result) => {
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText = result.Instruction;
      instructionText = instructionText.replace('<img ', '<img title="Header" ')
      this.instructionText = instructionText;
      this.referalFormPart1.valueChanges.subscribe(() => this.formValidate());
      this.referalFormPart2.valueChanges.subscribe(() => this.formValidate());
      this.referalFormPart3.valueChanges.subscribe(() => this.formValidate());
      this.referalFormPart4.valueChanges.subscribe(() => this.formValidate());
    });
    this.loadPartiesInvolved();
  }
  loadPartiesInvolved() {
        this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {

      let selectedpartyId = this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value;
      let selectedparty = result.find(x => x.Id == selectedpartyId);
      if (selectedparty) {
        this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
      }
    });
    this.vendorService.getRequiredFields(this.payorkey).subscribe((result) => {
      this.referalFormDataPart1.subcontrols.find((x: { name: string; }) => x.name == "wFirstName").validators.required = result.WitnessFirstName;
      this.referalFormDataPart1.subcontrols.find((x: { name: string; }) => x.name == "wLastName").validators.required = result.WitnessLastName;
      this.referalFormDataPart1.subcontrols.find((x: { name: string; }) => x.name == "wAgencyName").validators.required = result.WitnessAgencyName;
      this.referalFormDataPart1.subcontrols.find((x: { name: string; }) => x.name == "wRelationShip").validators.required = result.WitnessRelationshiptoSubject;
      this.referalFormDataPart1.subcontrols.find((x: { name: string; }) => x.name == "phone").validators.required = result.WitnessPhoneNumber;

      this.referalFormDataPart2.subcontrols.find((x: { name: string; }) => x.name == "email").validators.required = result.WitnessEmail;
      this.referalFormDataPart2.subcontrols.find((x: { name: string; }) => x.name == "wAddress1").validators.required = result.WitnessAddress;
      this.referalFormDataPart2.subcontrols.find((x: { name: string; }) => x.name == "city").validators.required = result.WitnessCity;

      this.referalFormDataPart3.subcontrols.find((x: { name: string; }) => x.name == "state").validators.required = result.WitnessState;
      this.referalFormDataPart4.subcontrols.find((x: { name: string; }) => x.name == "zip").validators.required = result.WitnessZIP;



      this.isformloaded = true;
    });

    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
    this.vendorService.getStateNames().subscribe((result) => {
      this.referalFormDataPart3.subcontrols.find((x: { name: string; }) => x.name == "state").options = result.map(x => { return { "value": x.Abbreviation, "key": x.Abbreviation } });
      setTimeout(() => {
        const stateValue = this.referalFormDataPart3.subcontrols.find((x: { name: string; }) => x.name == "state").value;
        if (stateValue) {
          (this.referalFormPart3.get('state') as any)?.setValue(stateValue);
        }
      }, 10);
    });
  }
  referalFormSubmit() {
    var tempArr = {
      controls: [],
      subcontrols: []
    }
    if (this.isExternalReferringParty == 'Yes') {
      if (this.referalForm.valid && this.referalFormPart1.valid && this.referalFormPart2.valid &&
        this.referalFormPart3.valid && this.referalFormPart4.valid) {
        tempArr.controls = this.referalFormData.controls;
        tempArr.subcontrols = this.referalFormDataPart1.subcontrols.concat(this.referalFormDataPart2.subcontrols, this.referalFormDataPart3.subcontrols, this.referalFormDataPart4.subcontrols);
      }
    } else {
      tempArr.controls = this.referalFormData.controls;
      tempArr.subcontrols = this.referalFormDataPart1.subcontrols.concat(this.referalFormDataPart2.subcontrols, this.referalFormDataPart3.subcontrols, this.referalFormDataPart4.subcontrols);
    }
    this.formdata.extenalReferall = tempArr;
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    if (this.profileMasterTypeKey === 1) {
      this.router.navigate(['provider']);
    }
    else if (this.profileMasterTypeKey === 2) {
      this.router.navigate(['member']);
    }
    else if (this.profileMasterTypeKey === 3) {
      this.router.navigate(['nonEnumeratedProvider']);
    }
    else if (this.profileMasterTypeKey === 4) {
      this.router.navigate(['nonEnumeratedOrganization']);
    }
    else if (this.profileMasterTypeKey === 5) {
      this.router.navigate(['nonEnumeratedIndividual']);
    }
  }

  back() {
    this.formdata.extenalReferall = this.referalFormData;
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    this.router.navigate(['witness']);
  }

  valueChange(data: any) {
    if (data.name == 'isExternalReferal') {
      this.isExternalReferringParty = data.value.srcElement.value;
    }
    this.formValidate();
  }

  openInstruction() {

    const result = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    result.componentInstance.name = this.instructionText;
  }

  formValidate() {
    if (this.isExternalReferringParty == 'Yes') {
      setTimeout(() => {
        if (this.referalForm.valid && this.referalFormPart1.valid && this.referalFormPart2.valid &&
          this.referalFormPart3.valid && this.referalFormPart4.valid) {
          this.isFormsValid = true;
        } else {
          this.isFormsValid = false;
        }
      }, 200);
    } else if (this.isExternalReferringParty == "No") {
      if (this.referalForm.valid) {
        this.isFormsValid = true;
      } else {
        this.isFormsValid = false;
      }
    }
  }

}
